// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xr1SI","newExpiryDate":"styles_newExpiryDate__2Eccb","footer":"styles_footer__2qe00"};